module.exports = __webpack_public_path__ + "static/media/thumbpoll-logo-mini.c20366a0.png";